export default "__VITE_ASSET__d7d0eb01__"